var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chartData.datasets && _vm.chartData.datasets.length > 0)?_c('RiskmaLine',{attrs:{"options":_vm.chartOptions,"data":_vm.chartData,"height":_vm.$vuetify.breakpoint.lgAndUp ? '170px' : '200px'}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }